export default __webpack_public_path__ + "static/logo-2-3d9beb35248476886a05d3f58b6ebeb4.png";